import { isValidElement, type ReactNode } from "react";

const getItemKey = (item: ReactNode) => {
  if (isValidElement(item) && item.key !== null) {
    return String(item.key);
  }

  return String(item);
};

const getUniqueItemKey = (
  item: ReactNode,
  itemKeyOccurrences: Map<string, number>,
) => {
  const baseKey = getItemKey(item);
  const occurrence = itemKeyOccurrences.get(baseKey) ?? 0;
  itemKeyOccurrences.set(baseKey, occurrence + 1);

  return occurrence === 0 ? baseKey : `${baseKey}-${occurrence}`;
};

const createItemKeyResolver = () => {
  const itemKeyOccurrences = new Map<string, number>();

  return (item: ReactNode) => getUniqueItemKey(item, itemKeyOccurrences);
};

export { createItemKeyResolver, getItemKey };
export default createItemKeyResolver;
